module.exports = __webpack_public_path__ + "img/home-intro-pic.2a9f86a9.png";